var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuoteBegin({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.583 17.3203C3.553 16.2263 3 14.9993 3 13.0103C3 9.51027 5.457 6.37327 9.03 4.82227L9.923 6.20027C6.588 8.00427 5.936 10.3453 5.676 11.8213C6.213 11.5433 6.916 11.4463 7.605 11.5103C9.409 11.6773 10.831 13.1583 10.831 14.9993C10.831 15.9275 10.4623 16.8178 9.80587 17.4741C9.1495 18.1305 8.25926 18.4993 7.331 18.4993C6.258 18.4993 5.232 18.0093 4.583 17.3203ZM14.583 17.3203C13.553 16.2263 13 14.9993 13 13.0103C13 9.51027 15.457 6.37327 19.03 4.82227L19.923 6.20027C16.588 8.00427 15.936 10.3453 15.676 11.8213C16.213 11.5433 16.916 11.4463 17.605 11.5103C19.409 11.6773 20.831 13.1583 20.831 14.9993C20.831 15.9275 20.4623 16.8178 19.8059 17.4741C19.1495 18.1305 18.2593 18.4993 17.331 18.4993C16.258 18.4993 15.232 18.0093 14.583 17.3203Z",
    fill: "#DB233A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteBegin);
export default __webpack_public_path__ + "static/media/quoteBegin.897c1eab3740c1483dd1034bd5e4be65.svg";
export { ForwardRef as ReactComponent };